let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hhxSK")).then(() => parcelRequire('av7Mc'));